import { useEffect, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Button from './Button'
import { Alert } from '../utils/Alert'
import { firestore } from '../firebase'

export default function AppSettings() {

	const [data, setData] = useState<FirebaseFirestore.DocumentData | null>(null)
	const [showLoader, setShowLoader] = useState(false)

	useEffect(() => {
		fetchSettings()
	}, [])

	if (data == null) {
		return (
			<div style={{
				padding: 30,
				textAlign: 'center'
			}}>
				<CircularProgress />
			</div>
		)
	}

	return (
		<div style={{
			padding: 15
		}}>
			<div style={{
				display: 'flex',
				alignItems: 'center'
			}}>
				<Button
					containerStyle={{
						width: 200
					}}
					disabled={showLoader}
					onPress={onPressSave}
					title='Save' />
				{showLoader && (
					<CircularProgress size={20} style={{ marginLeft: 15 }} />
				)}
			</div>
		</div>
	)

	async function fetchSettings() {
		setShowLoader(true)
		try {
			const docSnapshot = await firestore().collection('settings').doc('app').get()
			setData(docSnapshot.data() ?? {})
		} catch (error) {
			Alert.alert('Error Fetching Settings', String(error))
		}
		setShowLoader(false)
	}

	async function onPressSave() {
		setShowLoader(true)
		try {
			if (data)
				await firestore().collection('settings').doc('app').set(data, { merge: true })
		} catch (error) {
			Alert.alert('Error Saving Settings', String(error))
		}
		setShowLoader(false)
	}
}
